export const footerFallbackRU = {
  id: 1,
  locale: 'ru',
  links: [
    {
      id: 4,
      title: 'RuStore магазин приложений',
      elements: [
        {
          id: 1,
          title: 'О RuStore',
          href: 'https://www.rustore.ru/help/users/about-rustore',
          isTargetBlank: true,
        },
        {
          id: 2,
          title: 'RuStore для TV',
          href: 'https://www.rustore.ru/tv',
          isTargetBlank: true,
        },
        {
          id: 3,
          title: 'RuStore для телефона',
          href: 'https://www.rustore.ru/instruction',
          isTargetBlank: false,
        },
        {
          id: 95,
          title: 'RuStore для ОС Аврора',
          href: 'https://www.rustore.ru/osaurora',
          isTargetBlank: true,
        },
        {
          id: 4,
          title: 'Медиа-кит (для СМИ и блогеров)',
          href: 'https://www.rustore.ru/media-kit',
          isTargetBlank: true,
        },
        {
          id: 5,
          title: 'Нашли уязвимость? (программа Bug Bounty)',
          href: 'https://bugbounty.vk.company',
          isTargetBlank: true,
        },
        {
          id: 6,
          title: 'Пользовательское соглашение',
          href: 'https://www.rustore.ru/help/legal/terms-of-use',
          isTargetBlank: true,
        },
        {
          id: 7,
          title: 'Конфиденциальность для пользователей',
          href: 'https://www.rustore.ru/help/legal/privacy-policy-users',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 1,
      title: 'Помощь',
      elements: [
        {
          id: 9,
          title: 'Установка RuStore на TV',
          href: 'https://www.rustore.ru/help/users/start/install-on-tv/install-apk-on-tv',
          isTargetBlank: true,
        },
        {
          id: 8,
          title: 'Установка RuStore на телефон',
          href: 'https://www.rustore.ru/help/users/start/app-install',
          isTargetBlank: true,
        },
        {
          id: 11,
          title: 'Помощь пользователям RuStore',
          href: 'https://www.rustore.ru/help/users/start',
          isTargetBlank: true,
        },
        {
          id: 10,
          title: 'Покупки и возвраты',
          href: 'https://www.rustore.ru/help/users/purchases-and-returns',
          isTargetBlank: true,
        },
        {
          id: 12,
          title: 'Авторизация в RuStore (SBER ID, VK ID)',
          href: 'https://www.rustore.ru/help/users/authorization',
          isTargetBlank: true,
        },
        {
          id: 13,
          title: 'Сбой обновления приложений',
          href: 'https://www.rustore.ru/help/users/app-management/update-failure',
          isTargetBlank: true,
        },
        {
          id: 15,
          title: 'Родительский контроль',
          href: 'https://www.rustore.ru/parental-control',
          isTargetBlank: true,
        },
        {
          id: 14,
          title: 'Как написать отзыв к приложению',
          href: 'https://www.rustore.ru/help/users/app-management/app-review',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 3,
      title: 'Разработчикам',
      elements: [
        {
          id: 16,
          title: 'Зарабатывать с RuStore',
          href: 'https://www.rustore.ru/help/developers/monetization',
          isTargetBlank: true,
        },
        {
          id: 17,
          title: 'Стать разработчиком',
          href: 'https://www.rustore.ru/help/developers',
          isTargetBlank: true,
        },
        {
          id: 18,
          title: 'Доступ к RuStore Консоль',
          href: '/developer',
          isTargetBlank: true,
        },
        {
          id: 19,
          title: 'RuStore SDK (документация)',
          href: 'https://www.rustore.ru/help/sdk',
          isTargetBlank: true,
        },
        {
          id: 21,
          title: 'Регистрация иностранной компании',
          href: 'https://www.rustore.ru/help/developers/developer-account/registration-developer/foreign-company-developer-account',
          isTargetBlank: true,
        },
        {
          id: 20,
          title: 'Соглашение о распространении',
          href: 'https://www.rustore.ru/help/legal/developers-agreement',
          isTargetBlank: true,
        },
        {
          id: 24,
          title: 'Конфиденциальность для разработчиков',
          href: 'https://www.rustore.ru/help/legal/privacy-policy-developers',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 9,
      title: 'Популярные категории',
      elements: [
        {
          id: 55,
          title: 'Игры для Android',
          href: 'https://www.rustore.ru/catalog/games',
          isTargetBlank: true,
        },
        {
          id: 56,
          title: 'Приложения банков',
          href: 'https://www.rustore.ru/catalog/finance',
          isTargetBlank: true,
        },
        {
          id: 57,
          title: 'Государственные',
          href: 'https://www.rustore.ru/catalog/state',
          isTargetBlank: true,
        },
        {
          id: 58,
          title: 'Родителям',
          href: 'https://www.rustore.ru/catalog/parenting',
          isTargetBlank: true,
        },
        {
          id: 59,
          title: 'Приложения для шопинга',
          href: 'https://www.rustore.ru/catalog/purchases',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 2,
      title: 'Блог',
      elements: [
        {
          id: 22,
          title: 'Обзоры игр и статьи о мобильных приложениях',
          href: '/prostore',
          isTargetBlank: true,
        },
        {
          id: 144,
          title: '7 детских игр на Android',
          href: '/prostore/detskie-igry-na-android',
          isTargetBlank: true,
        },
        {
          id: 142,
          title: '10 приложений для Android TV',
          href: '/prostore/10-prilozhenij-dlya-android-tv',
          isTargetBlank: true,
        },
        {
          id: 143,
          title: '20 приложений для Москвы',
          href: '/prostore/prilozhenija-dlja-moskvichej',
          isTargetBlank: true,
        },
        {
          id: 145,
          title: '8 мобильных игр про хомяков',
          href: '/prostore/vmesto-tysjachi-tapov-8-mobilnyh-igr-pro-homjakov',
          isTargetBlank: true,
        },
        {
          id: 26,
          title: '10 приложений для детского телефона',
          href: '/prostore/10-prilozhenij-dlya-detskogo-telefona-interesno-i-bezopasno',
          isTargetBlank: true,
        },
        {
          id: 146,
          title: '20 приложений для Санкт-Петербурга',
          href: '/prostore/prilozhenija-dlja-peterburzhcev',
          isTargetBlank: true,
        },
        {
          id: 60,
          title: 'Как оплачивать покупки телефоном в 2024 году?',
          href: '/prostore/kak-polzovatsya-telefonom-vmesto-karty-beskontaktnye-platezhi-android',
          isTargetBlank: true,
        },
        {
          id: 147,
          title: '10 самых полезных государственных сервисов',
          href: '/prostore/podborka-gosudarstvennyh-servisov',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 20,
      title: 'Подборки',
      elements: [
        {
          id: 130,
          title: 'Игровой набор',
          href: 'https://www.rustore.ru/catalog/featuring/abfbb9fb-1d3c-4234-86cb-798836967b29',
          isTargetBlank: true,
        },
        {
          id: 131,
          title: 'Финансы',
          href: 'https://www.rustore.ru/catalog/featuring/a5aa70f3-d3fd-472c-816b-9011ab6bfedc',
          isTargetBlank: true,
        },
        {
          id: 133,
          title: 'Самое необходимое',
          href: 'https://www.rustore.ru/catalog/featuring/9d90c399-7702-4b83-aa2e-0b03d626ebe9',
          isTargetBlank: true,
        },
        {
          id: 140,
          title: 'Полезные инструменты',
          href: 'https://www.rustore.ru/catalog/featuring/7d5a4980-616d-40ae-b5f2-9a49db6028ad',
          isTargetBlank: true,
        },
        {
          id: 132,
          title: 'Новинки недели',
          href: 'https://www.rustore.ru/catalog/featuring/7341999c-1bde-44a9-83c2-434eca91bacc',
          isTargetBlank: true,
        },
        {
          id: 134,
          title: 'Высокий рейтинг',
          href: 'https://www.rustore.ru/catalog/featuring/6d0c1915-bb95-4408-ab78-3942fc84199a',
          isTargetBlank: true,
        },
      ],
    },
  ],
  leftSideContent: {
    id: 1,
    copyright: '© VK 2022—2025 RuStore',
    qrCodeDescription:
      'Наведите камеру <br /> для загрузки RuStore <br /> и следуй <a href="https://www.rustore.ru/instruction">инструкции</a>',
    rustoreLogoHref: {
      id: 1532,
      name: 'logo_color_30 px.svg',
      width: 128,
      height: 32,
      url: 'https://static.rustore.ru/rustore-strapi/6/logo_color_30_px_57aa562dd4.svg',
    },
    qrCodeHref: {
      id: 1533,
      name: 'qr-code.svg',
      width: 160,
      height: 160,
      url: 'https://static.rustore.ru/rustore-strapi/6/QR_code_28c023f346.svg',
    },
    webLandingSocialLinks: [
      {
        id: 2,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 1535,
          name: 'Iko_VK_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 1,
        href: 'https://dzen.ru/rustore',
        isTargetBlank: true,
        logoHref: {
          id: 1534,
          name: 'Iko_dzen_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_dzen_28_9dacd5d21f.svg',
        },
      },
    ],
    devLandingSocialLinks: [
      {
        id: 4,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 1535,
          name: 'Iko_VK_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 26,
        href: 'https://t.me/rustoredev',
        isTargetBlank: true,
        logoHref: {
          id: 2625,
          name: 'telegram.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/telegram_905e827f78.svg',
        },
      },
    ],
    webSocialLinks: [
      {
        id: 5,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 1535,
          name: 'Iko_VK_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_VK_28_2368eb6a8b.svg',
        },
      },
    ],
  },
};
